// Vue plugin <eui-panel>:


import { euiLifecycleStatusesMixin } from 'v-mixins/euiLifecycleStatusesMixin';

import euiPopUpMenyClasses from 'v-components/classes/euiPopUpMenyClasses';
import euiMermeny from 'v-components/euiMermeny';

// Gemensam för alla sådana här komponenter på en sida, vilket är precis det vi vill:
let uniktIdCounter = 0;


//###################################################################################################

export default {

	name: 'eui-panel',

	template: `
		<div class="_eui-panel -ram"
			:class="{ '-inaktiverad':skaVaraInaktiverad, '-osynlig':skaVaraOsynlig }"
			:disabled="skaVaraInaktiverad"
		>

			<!-- ####### Huvudet: -->

			<div v-if="vpVisaHuvudet"
				class="_eui-panel_huvud -vit-bg"
			>
				<span class="_eui-panel_huvudtext ellipsis">
					<slot name="huvudtext">
						<span v-html="vpHuvudText"></span>
					</slot>
				</span>

				<span v-if="vpVisaMenyfaltet && menyConfig"
					class="_eui-panel_menyfalt"
				>
					<!-- ####### Mermenyn: -->
					<eui-mermeny
						:vp-meny-config.sync="menyConfig"
						vp-burgare-ikon-av-storlek="1.7rem"
						@menyalternativ-valt-i-mermeny="onMenyalternativValt"
						style="width:40px; height:100%; display:inline-flex;"
					></eui-mermeny>
				</span>
			</div>

			<!-- ####### Kroppen: -->

			<div class="_eui-panel_kropp -vit-bg">
				<slot></slot>
			</div>

			<!-- ####### Foten: -->

			<div v-if="vpVisaFoten"
				class="_eui-panel_fot -vit-bg"
			>
				<span class="_eui-panel_fottext ellipsis">
					<slot name="fottext">
						<span v-html="vpFotText"></span>
					</slot>
				</span>
			</div>

		</div>
	`,

	components: {
		//[euiBurgare.component.name]: euiBurgare.component,
		//[euiPopUpMeny.name]: euiPopUpMeny,
		[euiMermeny.name]: euiMermeny
	},

	mixins: [ euiLifecycleStatusesMixin ],

	props: {
		vpVisaHuvudet: {
			type: Boolean,
			default: true
		},
		vpHuvudText: {
			type: String,		// Får innehålla viss inline html.
			default: null
		},

		vpVisaMenyfaltet: {
			type: Boolean,
			default: false
		},

		// Denna ska användas med .sync, dvs automagiskt lyssna på eventet 'update:vpMenyConfig':
		vpMenyConfig: {	// null/undefined = saknas
			type: [euiPopUpMenyClasses.menyConfig, Object],
			default: null,
		},

		vpVisaFoten: {
			type: Boolean,
			default: false
		},
		vpFotText: {
			type: String,		// Får innehålla viss inline html.
			default: null
		},

		vpInaktiverad: {
			type: Boolean,
			default: false
		},
		vpOsynlig: {
			type: Boolean,
			default: false
		},
	},

	data() {
		return {
			uniktId: 'eui-panel-unikt-' + (++uniktIdCounter),
			//burgarenEl: undefined,
			//visaMermenyn: false,

			menyConfig: this.vpMenyConfig,
		};
	},

	computed: {
		skaVaraOsynlig() {
			return (this.vpOsynlig || !this.lifecycleStatuses.mixinMountedAndNextTickHasOccured);	//AndSecondNextTickHasOccured);
		},

		skaVaraInaktiverad() {
			return (this.vpInaktiverad);				// || !this.lifecycleStatuses.mixinMountedAndSecondNextTickHasOccured);
		},
	},

	watch: {
		vpMenyConfig: {
			// Obs! Denna watch är "deep"!
			handler(nyttVarde, tidigareVarde)
			{
				this.menyConfig = nyttVarde;
			},
			deep: true,
		},

		menyConfig: {
			// Obs! Denna watch är "deep"!
			handler(nyttVarde, tidigareVarde)
			{
				// Propen används med .sync i parent component:
				this.$emit('update:vpMenyConfig', nyttVarde);
			},
			deep: true,
		},


		//vpVisaMenyfaltet(nyttVarde, tidigareVarde) {
		//	if (nyttVarde === true)
		//	{
		//		// Backat på, för denna anropas inte initialt alltid. Dock sätts den till undefined i denna watch (nedan):
		//		// På prov flyttad hanteringen från updated() hit, se kommentar där:
		//		//this.burgarenEl = this.$el.querySelector('._eui-burgare');
		//	}
		//	else
		//	{
		//		this.burgarenEl = undefined;
		//	}
		//},
	},

	methods: {
		onMenyalternativValt({ eventId, eventData }) {

			this.$emit('menyalternativ-valt-i-panel',
				// Payload:
				{ eventId: eventId, eventData: eventData }
			);
		},
	},

	//created() {
	//	// Deklaration av "private" variabler, som är "non reactive properties of this instance" (ett alt sätt är att anv data, men sätta värdet till Object.freeze(värde)):
	//	// Exempel: this.$_undertryckNastaAndradEvent = false;
	//},

	//mounted() {
	//	// Note that mounted does not guarantee that all child components have also been mounted.
	//	//-----------------------------------------------------------------------------------------------------------------------
	//	// Mixin hooks will be called *before* the component’s/app’s own hooks. Ordning:
	//	//
	//	// 1. Mixins mounted hook.
	//	// 2. Appens/komponentens mounted hook.
	//	//
	//	// 3. Mixins mounted hook + nextTick (DOM not updated yet).
	//	// 4. Appens/komponentens mounted hook + nextTick (DOM not updated yet).
	//	//
	//	// 5. Mixins mounted hook + nextTick (DOM not updated yet) + ytterligare ett Vue.nextTick (DOM updated).
	//	// 6. Appens/komponentens mounted hook + nextTick (DOM not updated yet) + ytterligare ett Vue.nextTick (DOM updated).
	//	//
	//	// Det är *först efter steg 4* ovan som allt är färdigrenderat, med avseende på Vue-grejs som exempelvis all reaktivitet som förekommer i appen (ex visa/dölj element)!
	//	//
	//	// Alltså, saker som ska göras i denna mixins mounted och som ska ske *efter* steg 2 ovan:
	//	// a) kan göras som steg 3 ovan, *om* det *inte* är beroende av att allt reaktivt är garanterat färdigrenderat eller
	//	// b) måste göras som steg 5 ovan, *om* det är beroende av att allt reaktivt är garanterat färdigrenderat.
	//	//-----------------------------------------------------------------------------------------------------------------------

	//	//## 2. Appens/komponentens mounted hook:  #################################
	//	//console.log('2. Appens/komponentens mounted hook');

	//	this.$nextTick(function () {
	//		// Code that will run only after the entire Vue view has been rendered (= guarantee that all child components have also been mounted):
	//		// This is the same as the global Vue.nextTick, except that the callback’s this context is automatically bound to the instance calling this method:

	//		//## 4. Appens/komponentens mounted hook + nextTick (DOM not updated yet):  #################################
	//		//console.log('4. Appens/komponentens mounted hook + nextTick');

	//		// Flyttad till updated(), för annars sätts den inte om efter v-if="false" –> "true":
	//		//this.burgarenEl = this.$el.querySelector('._eui-burgare');
	//	});
	//},

	//beforeUpdate()
	//{
	//	// Called when data changes, before the DOM is patched. This is a good place to access the existing DOM before an update, e.g. to remove manually added event listeners.
	//	// This hook is not called during server-side rendering, because only the initial render is performed server-side.
	//	// Obs! Det är ganska lätt att hamna i ett läge där denna anropas multipla ggr, dvs man ändrar flera responsiva saker och då triggas denna 1 gg för varje (?), typ!
		// Obs! "The lifecycle hooks around update respond to changes in the DOM. Watchers respond to changes in the data. DOM changes are generally in response to data changes, but they might not be data owned by the component in question."
	//},

	//updated()
	//{
	//	// Called after a data change causes the virtual DOM to be re-rendered and patched.
	//	// The component’s DOM will have been updated when this hook is called, so you can perform DOM-dependent operations here. However, in most cases you should avoid changing state inside the hook. To react to state changes, it’s usually better to use a computed property or watcher instead.
	//	// This hook is not called during server-side rendering.
	//	// Note that updated does not guarantee that all child components have also been re-rendered.
	//	// Denna hook körs även efter mounted!
	//	// Obs! Det är ganska lätt att hamna i ett läge där denna anropas multipla ggr, dvs man ändrar flera responsiva saker och då triggas denna 1 gg för varje (?), typ!
		// Obs! "The lifecycle hooks around update respond to changes in the DOM. Watchers respond to changes in the data. DOM changes are generally in response to data changes, but they might not be data owned by the component in question."
	//	//console.log('updated: panel');

	//	this.$nextTick(function () {
	//		// Code that will run only after the entire Vue view has been rendered (= guarantee that all child components have also been mounted):
	//		// This is the same as the global Vue.nextTick, except that the callback’s this context is automatically bound to the instance calling this method:


	//		// Backat på, för watchen anropas inte initialt alltid:
	//		// På prov tagit detta ett steg längre, enl kommentaren "... in most cases you should avoid changing state inside the hook. To react to state changes, it’s usually better to use a computed property or watcher instead." ovan, och flyttad detta till en watch på vpVisaMenyfaltet istället. Dock lite osäker på hur detta funkar med avseende på $nextTick-hanteringen här, som inte finns i watchern! Det ger sig:

	//		// Flyttad hit från mounted(), för annars sätts den inte om efter v-if="false" –> "true":
	//		// (Den nollas (undefined) i en watch.)
	//		this.burgarenEl = this.$el.querySelector('._eui-burgare');
	//	});
	//},

	//activated()
	//{
	//	// Called when a *kept-alive* component is activated.
	//	// This hook is not called during server-side rendering.
	//},

	//deactivated()
	//{
	//	// Called when a *kept-alive* component is deactivated.
	//	// This hook is not called during server-side rendering.
	//},

	//beforeDestroy()
	//{
	//	// Called right before a Vue instance is destroyed. At this stage the instance is still fully functional.
	//	// This hook is not called during server-side rendering.
	//	//console.log('beforeDestroy: panel');
	//},

	//destroyed()
	//{
	//	// Called after a Vue instance has been destroyed. When this hook is called, all directives of the Vue instance have been unbound, all event listeners have been removed, and all child Vue instances have also been destroyed.
	//	// This hook is not called during server-side rendering.
	//},
};
